import {
    get,
    post,
    put
} from "./http";
import qs from 'qs'

// 新闻列表---分页
export const articlePage = (params) => {
    let url = "/jysk/brain/industrial/article/page";
    return get(url, params);
}

//新闻详情
export const articleInfo = (params) => {
    let url = "/jysk/brain/industrial/article/getInfo";
    return get(url, params);
}

//新闻详情--年份
export const articleYearList = (params) => {
    let url = "/jysk/brain/industrial/article/yearList";
    return get(url, params);
}

